import { useAuth } from "../../components/context/AuthContext";

const ProfilePage = () => {
  const { token } = useAuth();

  return (
    <div className="p-4 text-white bg-black">
      <h1 className="text-xl">Welcome to Your Profile</h1>
      <p>Your token: {token}</p>
    </div>
  );
};

export default ProfilePage;
